import { api } from "@/lib/api";

/** Fetch current logged-in user (Google-auth). Returns null if not authed. */
export async function fetchUser() {
  try {
    const { data } = await api.get("/user/auth/me");
    return data;
  } catch {
    return null;
  }
}

export async function logoutUser() {
  try {
    await api.post("/user/auth/logout");
  } catch (e) {
    console.warn("logout call failed", e);
  }
}

export async function exchangeSession(session_id) {
  const { data } = await api.post("/user/auth/session", { session_id });
  return data;
}

/** Redirect to Emergent Google Auth.
 *  REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/me";
  window.location.href =
    `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function listWatchlist() {
  const { data } = await api.get("/user/watchlist");
  return data;
}

export async function addWatchlist(trend) {
  const { data } = await api.post("/user/watchlist", {
    trend_id: trend.id,
    term: trend.term,
    country: trend.country,
    category: trend.category,
  });
  return data;
}

export async function removeWatchlist(trend_id) {
  const { data } = await api.delete(`/user/watchlist/${encodeURIComponent(trend_id)}`);
  return data;
}
